import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useCart } from "../Context/CartContext";
import { getAllCategories } from "../actions/categoryActions";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";


const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "73.3%",
    zIndex: 1000,
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "width 0.3s ease, left 0.3s ease",
    boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
    borderTop: "1px solid #e0e0e0",
    padding: theme.spacing(0.5, 0),
  },
  list: {
    display: "flex",
    overflowX: "auto",
    padding: theme.spacing(0.5, 1),
    flex: 1,
    "&::-webkit-scrollbar": {
      height: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "2px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "2px",
      "&:hover": {
        background: "#555",
      },
    },
    scrollbarWidth: "thin",
    scrollbarColor: "#888 #f1f1f1",
  },
  listItem: {
    marginRight: theme.spacing(1.5),
    fontWeight: 500,
    backgroundColor: "white",
    textAlign: "center",
    minWidth: "120px",
    borderRadius: "24px",
    border: "2px solid #e0e0e0",
    cursor: "pointer",
    transition: "all 0.2s ease",
    padding: theme.spacing(0.75, 2),
    "&:hover": {
      borderColor: "rgb(239, 127, 26)",
      backgroundColor: "#fff5e6",
    },
  },
  selectedItem: {
    backgroundColor: "rgb(239, 127, 26)",
    color: "white",
    border: "2px solid rgb(239, 127, 26)",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "rgb(220, 110, 20)",
      borderColor: "rgb(220, 110, 20)",
    },
  },
  arrowIcons: {
    backgroundColor: "rgb(239, 127, 26)",
    "&:hover": {
      backgroundColor: "rgb(220, 110, 20)",
    },
  },
}));

const FloatingFooter = ({ open }) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.categories);
  const { selectedCategory, setSelectedCategory } = useCart();

  const scrollLeft = () => {
    const list = document.getElementById("categoryList");
    if (list) {
      list.scrollBy({
        left: -150, // Adjust as needed for scroll amount
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    const list = document.getElementById("categoryList");
    if (list) {
      list.scrollBy({
        left: 150, // Adjust as needed for scroll amount
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    if (!categories.length) {
      dispatch(getAllCategories());
    }
  }, [dispatch, categories]);
  const numCategories = categories.length;
  const listItemWidth =
    numCategories * 150 > 1100 ? "150px" : `${1100 / numCategories}px`;

  return (
    <Paper
      className={classes.root}
      elevation={0}
      style={{ 
        width: open ? "calc(100% - 530px)" : "100%",
        left: 0,
      }}
    >
      <IconButton 
        onClick={scrollLeft} 
        className={classes.arrowIcons}
        style={{
          marginLeft: theme.spacing(1),
          color: "white",
          padding: theme.spacing(1),
        }}
      >
        <ArrowBackIcon />
      </IconButton>
      <List id="categoryList" className={classes.list}>
        <ListItem
          className={`${classes.listItem} ${selectedCategory === null ? classes.selectedItem : ''}`}
          style={{ width: listItemWidth, justifyContent: "center" }}
          onClick={() => setSelectedCategory(null)}
        >
          <Typography variant="body1" style={{ fontWeight: 600 }}>
            All
          </Typography>
        </ListItem>
        {categories.map((category, index) => (
          <ListItem
            key={index}
            className={`${classes.listItem} ${selectedCategory === category ? classes.selectedItem : ''}`}
            style={{ width: listItemWidth, justifyContent: "center" }}
            onClick={() => setSelectedCategory(category)}
          >
            <ListItemText 
              primary={category.categoryName} 
              primaryTypographyProps={{ 
                style: { 
                  fontWeight: selectedCategory === category ? 600 : 500,
                  textAlign: "center"
                } 
              }}
            />
          </ListItem>
        ))}
      </List>
      <IconButton 
        onClick={scrollRight} 
        className={classes.arrowIcons}
        style={{
          marginRight: theme.spacing(1),
          color: "white",
          padding: theme.spacing(1),
        }}
      >
        <ArrowForwardIcon />
      </IconButton>
    </Paper>
  );
};

export default FloatingFooter;
